import * as React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import api from "../services/api";
import { PROGRAMA_ID } from "../config";
import { userTemPrograma } from "../helpers/programa";

// Perfis que podem ser Interlocutor Departamento Regional - sempre vinculados ao
// PotencializEE Nacional e do estado do processo. A API valida a mesma lista em
// ProcessosController.setInterlocutores.
const PERFIS_INTERLOCUTOR = ["consultorEE", "consultorMercado", "gestorSENAI"];
const NOME_PERFIL = {
  consultorEE: "Especialista EE",
  consultorMercado: "Consultor de Mercado",
  gestorSENAI: "Gestor SENAI",
};

const InterlocutorPicker = ({ label, roleIds, programaId, estado, atual, user, onSalvar }) => {
  const [usuarios, setUsuarios] = React.useState([]);
  const [buscando, setBuscando] = React.useState(true);
  const [selecionadoId, setSelecionadoId] = React.useState(atual?.id || "");
  const [salvando, setSalvando] = React.useState(false);

  React.useEffect(() => {
    setBuscando(true);
    api.http
      .get("/users", {
        params: { roleId: roleIds, programaId, habilitado: true, ordenado_alfa: true, uf: estado || undefined },
      })
      // o /users também devolve quem não tem programa nenhum - aqui só serve quem é do programa
      .then((res) => setUsuarios((res.data || []).filter((u) => userTemPrograma(u, programaId))))
      .catch((error) => console.error(`Erro ao buscar usuários (${roleIds.join(", ")}):`, error))
      .finally(() => setBuscando(false));
  }, [roleIds, programaId, estado]);

  const salvar = async (id) => {
    if (!id) return;
    setSalvando(true);
    try {
      await onSalvar({ id });
    } finally {
      setSalvando(false);
    }
  };

  const podeAssumir = roleIds.includes(user?.roleId) && userTemPrograma(user, programaId) && user?.id !== atual?.id;

  return (
    <Box sx={{ width: "100%", my: 2 }}>
      {atual && <Alert severity="info" sx={{ mb: 1 }}>{label} atual: {atual.nome} ({atual.email})</Alert>}
      <FormControl sx={{ width: "100%", mb: 1 }}>
        <TextField
          select
          label={label}
          value={selecionadoId}
          onChange={(e) => setSelecionadoId(e.target.value)}
        >
          {usuarios.map((u) => (
            <MenuItem key={u.id} value={u.id}>
              {u.nome} - {NOME_PERFIL[u.roleId] || u.roleId} ({u.email})
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
      {!buscando && usuarios.length === 0 && (
        <Alert severity="warning" sx={{ mb: 1 }}>
          Nenhum {label.toLowerCase()} encontrado para o estado {estado || "deste processo"}.
        </Alert>
      )}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="outlined" onClick={() => salvar(selecionadoId)} disabled={salvando || !selecionadoId}>
          {salvando ? <CircularProgress size={20} /> : `Salvar ${label}`}
        </Button>
        {podeAssumir && (
          <Button variant="contained" onClick={() => salvar(user.id)} disabled={salvando}>
            Assumir este processo
          </Button>
        )}
      </Box>
    </Box>
  );
};

/**
 * Vincula o Interlocutor Departamento Regional responsável pelo processo (M&A/PROCEL) - só usuários já cadastrados.
 * Pode ser Especialista EE, Consultor de Mercado ou Gestor SENAI vinculado ao PotencializEE Nacional e do estado do processo.
 */
const InterlocutoresSection = ({ processoId, estado, interlocutorMercado, user, onAtualizado }) => {
  const salvar = async (campo, dados) => {
    const { data } = await api.http.put(`/processos/${processoId}/interlocutores`, {
      [campo]: dados,
    });
    if (onAtualizado) onAtualizado(data);
  };

  return (
    <>
      <Divider>
        <h3>Interlocutores responsáveis</h3>
      </Divider>
      <InterlocutorPicker
        label="Interlocutor Departamento Regional"
        roleIds={PERFIS_INTERLOCUTOR}
        programaId={PROGRAMA_ID.PROCEL}
        estado={estado}
        atual={interlocutorMercado}
        user={user}
        onSalvar={(dados) => salvar("interlocutorMercado", dados)}
      />
    </>
  );
};

export default InterlocutoresSection;
